// periods
import React from 'react';
import {
    gql, useFragment, useQuery, useReactiveVar,
} from '@apollo/client';
import { selectedPeriodVar } from 'app/apollo/reaction';


export const BASKET_PAGE_ROOT_QUERY_INITIAL_COPY = gql`
    query BASKET_PAGE_ROOT_QUERY_COPY_RESOLVER(
    $period: String!
) {
    cart(
        period: $period
    ) {
        period
        isSubscriptionActivated
        id
        typeOfSet
        haveDishesFromTrial
        isSectionsEmpty @client
        type
        __typename
        sections {
            id
            title
            gift_category
            cartType
            items {
                ...ROOT_CART_DISH_ITEM
                dish {
                    ...ROOT_MENU_DISH_ITEM
                }
            }
            __typename
        }
        totals {
            ...ROOT_CART_TOTAL
        }
        discount_conditions {
            ...ROOT_CART_DISCOUNT_CONDITIONS
        }
    }
}`;

const ROOT_CART_FRAGMENT = gql`
    fragment ROOT_CART_FRAGMENT on cart {
        period
        typeOfSet
        haveDishesFromTrial
        id
        type
        sections {
            id
            title
            gift_category
            cartType
            items {
                ...ROOT_CART_DISH_ITEM
                    dish {
                    ...ROOT_MENU_DISH_ITEM
                }
            }
        }
        totals {
            # FRNT-2607
            # Легаси поля, от которых нужно отказаться
            total_price
            total_discount_price
            total_common_price
            delivery_price
            promocode_applied
            promocode_amount
            discount_amount
            static_discount_price
            static_common_price
            referral_amount
            # FRNT-2607
            # Новые поля, на которые нужно перейти и отказаться от использования полей выше
            dishesPrice
            deliveryPrice
            subscriptionDiscountAmount
            promocodeDiscountAmount
            specialDiscountAmount
            subscriptionPrice
            onlinePrice
            cashPrice
            cashbackReward
            cashback_amount
            referral_amount
            applied_discount_amount
        }
        discount_conditions {
            promocode
            promocode_status
            isCertificate
            isPromoCodeActivated
            promoCodeApplyingErrorMessage
            isPromocodeCombineWithDiscount
            isPromocodeCombineWithAccount
            differenceBetweenPromocodeAndOrder
            isPromoCodeExists
            isSubscriptionActivated
            deliveriesCount
            discountType
            discountValue
            discountDuration
        }

    }
    #     $period: String!
    # ) {
    #     cart(
    #         period: $period
    #     ) {

            # primetiveSection @client

    #     }

    # }
`;

const initial = {
    cart: {
        sections: [],
        totals: {
            delivery_price: 0,
        },
    },
};

export const useBasketData = (
    // query = CART_DATA_FOR_MENU_QUERY,
    query = BASKET_PAGE_ROOT_QUERY_INITIAL_COPY,
    message = 'app:hook:useBasketData',
    fetchPolicy = 'cache-first',
) => {
    const period = useReactiveVar(selectedPeriodVar);

    const { data } = useQuery(query, {
        variables: {
            period,
        },
        context: {
            message,
        },
        fetchPolicy,
    });

    return data ?? initial;
};


/**
 * @description читает данные данные периудов, меню фильтров и из apollo cache
 */
export const useCachedBasketData = (fragment = ROOT_CART_FRAGMENT) => {
    const period = useReactiveVar(selectedPeriodVar);

    // const dasketData = useQuery(myBasket, {
    //     fetchPolicy: 'cache-first',
    //     variables: {
    //     },
    // });

    const { data } = useFragment({
        fragment,
        from: {
            __ref: `cart:new:${period}`,
        },
    });
    return data;
};
